import ActionTypes from '../actionTypes';
import Actions from '../Actions';
import { ZonesState } from './types';
import { StateStatus } from '../../enums/StateStatus';

export const defaultZonesState: ZonesState = {
  meansOfTransport: null,
  deliveryZones: null,
  operatingHoursFrom: '9:00:00',
  operatingHoursTo: '17:00:00',
  status: StateStatus.Initial,
  error: null
};

export default function reducer(state: ZonesState = defaultZonesState, action: Actions): ZonesState {
  switch (action.type) {
    case ActionTypes.GET_MEANS_OF_TRANSPORT:
    case ActionTypes.GET_DELIVERY_ZONES:
    case ActionTypes.MANAGE_DELIVERY_ZONE:
      return { ...state, error: null, status: StateStatus.Busy };
    case ActionTypes.GET_MEANS_OF_TRANSPORT_SUCCESS:
      return { ...state, status: StateStatus.Loaded, meansOfTransport: action.payload };
    case ActionTypes.GET_DELIVERY_ZONES_SUCCESS:
      return {
        ...state,
        error: null,
        status: StateStatus.Loaded,
        deliveryZones: action.payload.projectDeliveryZones,
        operatingHoursFrom: action.payload.operatingHoursFrom,
        operatingHoursTo: action.payload.operatingHoursTo
      };
    case ActionTypes.MANAGE_DELIVERY_ZONE_SUCCESS:
      return { ...state, error: null, status: StateStatus.Loaded };
    case ActionTypes.GET_MEANS_OF_TRANSPORT_ERROR:
    case ActionTypes.GET_DELIVERY_ZONES_ERROR:
    case ActionTypes.MANAGE_DELIVERY_ZONE_ERROR:
      return { ...state, status: StateStatus.Error, error: action.payload };
    default:
      return state;
  }
}
